import { useSearchParams } from "react-router-dom";
import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import { LogIn } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [params] = useSearchParams();
  const error = params.get("error");

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Section testid="login-page" className="pt-40 pb-40 min-h-[80svh]">
      <Container>
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-6">
            <Eyebrow>Student & Client Portal</Eyebrow>
            <DisplayH1 className="mt-6">Sign in to the University.</DisplayH1>
            <p className="mt-8 max-w-lg text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
              Your dashboard, courses, progress, and the Wolfkeeper Assistant — all connected
              in one place.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="card-lux p-10 max-w-md ml-auto">
              <div className="overline">Secure Sign-in</div>
              <div className="mt-3 font-serif-display text-3xl">One-click access</div>
              <p className="mt-3 text-sm text-[color:var(--wk-bone-dim)]">
                We use Emergent-managed Google authentication. Your credentials are never stored on our servers.
              </p>
              <button
                data-testid="login-google"
                onClick={handleLogin}
                className="btn-gold w-full mt-8 justify-center"
              >
                <LogIn size={16} /> Continue with Google
              </button>
              {error && <div className="mt-4 text-sm text-red-400">Sign-in failed. Please try again.</div>}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
